
import {
  computed, defineComponent, inject, Ref, ref,
} from 'vue';
import linkifyHtml from 'linkify-html';
import { useRoute } from 'vue-router';
import { descriptionWithLink } from '@/helpers/utils';
import { HIDE_BORDER, APPLICATION_SETTINGS_TYPE } from '@/types/enums';
import { useDriveStore } from '../../store/driveStore';
import { useMainStore } from '@/store/mainStore';
// import DriveFiles from '@/components/ViewSubpages/DriveFilesSubpage.vue';
import AppLabel from '@/components/AppLabel.vue';
// import DriveFiles from '@/modules/drive/components/ViewSubpages/DriveFilesSubpage.vue';
import DriveShareToggle from '../UI/DriveShareToggle.vue';

export default defineComponent({
  props: {
    isPreviewCase: { type: Boolean, default: false },
    skeleton: { type: Boolean, default: false },
  },
  components: {
    // DriveFiles,
    AppLabel,
    DriveShareToggle,
  },
  emits: ['goToFiles'],
  setup(props) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;
    const isPreview = computed(() => props.isPreviewCase);

    const isNetwork = computed(() => route.meta.isNetwork);
    const isNetworkOrDrive = computed(() => isNetwork.value || !isNetwork.value);

    const showAllDescription: Ref<boolean> = ref(false);

    const isPublicCases = computed(
      () => mainStore.applicationSettings.find((feature) => feature.name === APPLICATION_SETTINGS_TYPE.SHOW_PUBLIC_CASES_FEED)?.enabled,
    );
    const isPublicToggle = computed(
      () => mainStore.applicationSettings.find((feature) => feature.name === APPLICATION_SETTINGS_TYPE.SHOW_PUBLIC_CASES_TOGGLE)?.enabled,
    );

    const description = computed(() => {
      if (!driveStore.currentCase.description) {
        return $localize('drive.view.case.overview.tab.description');
      }
      if (showAllDescription.value) {
        return driveStore.currentCase.description;
      }
      return driveStore.currentCase?.description?.length >= 125 ? driveStore.currentCase.description.slice(0, 125) : driveStore.currentCase.description;
    });

    const noOverview = computed(() => !description.value && !driveStore.currentCase?.files?.length && !driveStore.currentCase?.labels?.length && isNetwork.value);

    return {
      driveStore,
      isNetworkOrDrive,
      showAllDescription,
      description,
      noOverview,
      isNetwork,
      HIDE_BORDER,
      mainStore,
      isPublicCases,
      isPreview,
      isPublicToggle,
      descriptionWithLink,
    };
  },
});
